import React from 'react';
import { contentTypes } from '../../constants';

// TODO check client site settings.format
const formatter = (value, format) => value;

/**
 * A component for rendering form fields based on value contentTypes
 *
 * @param {String | Boolean | Integer} value the default value to be set on the field
 * @param {String} format user defined display format
 * @param {String} type Currently expects ContentString, ContentNumber, ContentBoolean and ContentPassword
 * @param {Function} onChange Callback triggered by change event firing on the form field
 * @param {String} label A field label to be displayed
 * @param {Boolean} isRequired Determines whether to set an input to be required and display a red asterisk
 * @param {String} placeholder Placeholder text for text input type fields
 * @param {Boolean} disabled If true disable control, otherwise enabled
 */
const GenericFormField = ({ value, format = '', type, onChange, label, isRequired, placeholder, disabled = false }) => {

    let field = null;
    const requiredSnippet = isRequired ? <span className="input-required"> *</span> : null;

    switch (type ? type.toUpperCase() : null) {
    case contentTypes.boolean: {
        const booleanContentValue = typeof value === 'boolean'
            ? value
            : typeof value === 'string'
                ? value.toLowerCase() === 'true'
                : false;

        field = (
            <div className="checkbox">
                <label>
                    <input
                        required={isRequired}
                        onChange={onChange}
                        defaultChecked={booleanContentValue}
                        type="checkbox"
                        disabled={disabled}
                    />
                    &nbsp;
                    {label}
                    {requiredSnippet}
                </label>
            </div>
        );
        break;
    }
    case contentTypes.string:
    case contentTypes.encrypted:
    case contentTypes.content:
        field = (
            <React.Fragment>
                <label>
                    {label}
                    {requiredSnippet}
                </label>
                <textarea
                    required={isRequired}
                    onChange={onChange}
                    value={value}
                    className="form-control"
                    rows="3"
                    placeholder={placeholder}
                    disabled={disabled}
                />
            </React.Fragment>
        );
        break;
    case contentTypes.number:
        field = (
            <React.Fragment>
                <label>
                    {label}
                    {requiredSnippet}
                </label>
                <input
                    required={isRequired}
                    className="form-control"
                    onChange={onChange}
                    type="number"
                    value={value}
                    placeholder={placeholder}
                    disabled={disabled}
                />
            </React.Fragment>
        );
        break;
    case contentTypes.datetime:
        field = (
            <React.Fragment>
                <label>
                    {label}
                    {requiredSnippet}
                </label>
                <input
                    required={isRequired}
                    className="form-control"
                    onChange={onChange}
                    type="datetime-local"
                    value={value}
                    placeholder={placeholder}
                    disabled={disabled}
                />
            </React.Fragment>
        );
        break;
    case contentTypes.password:
        field = (
            <React.Fragment>
                <label>
                    {label}
                    {requiredSnippet}
                </label>
                <input
                    required={isRequired}
                    className="form-control"
                    onChange={onChange}
                    type="password"
                    value={value}
                    placeholder={placeholder}
                    autoComplete="new-password" // Prevent Chrome autofilling
                    disabled={disabled}
                />
            </React.Fragment>
        );
        break;
    default:
        field = (
            <React.Fragment>
                <label>
                    {label}
                    {requiredSnippet}
                </label>
                <input
                    required={isRequired}
                    className="form-control"
                    onChange={onChange}
                    type="text"
                    value={value}
                    placeholder={placeholder}
                    disabled={disabled}
                />
            </React.Fragment>
        );
        break;
    }

    return (
        <div className="form-group">
            {field}
        </div>
    );
};

export default GenericFormField;
